




































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
  get prox() {
    return new proxy.FinanceManageServiceProxy();
  }
  input: proxy.MerchantStatisticsPageInputDto = new proxy.MerchantStatisticsPageInputDto();
  sub_id = 0;
  createOrEditShow = false;
  createrange = [];
  BalanceTypes = [];
  merchants = [];
  totalOrderNum = 0;
  totalAmount = 0;
  commission = 0;
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },

    {
      title: '商户',
      key: 'merchantName',
      width: 240
    },
    {
      title: '商户号',
      key: 'mid',
      width: 240
    },
    // {
    //   title: '总笔数',
    //   key: 'totalOrderNum'
    // },
    // {
    //   title: '总金额',
    //   key: 'totalAmount'
    // },
    {
      title: '成功笔数',
      key: 'successOrderNum'
    },
    {
      title: '成功金额',
      key: 'successAmount'
    },
    {
      title:'补单数',
      key:'buDanNum'
    },
    {
      title:'补单金额',
      key:'buDanAmount'
    },
    {
      title: '服务费',
      key: "commission"
    },
    {
      title: '实到金额',
      key: 'merchantActualAmount'
    },
    {
      title: '利润',
      key: 'liRun',
    },
    // {
    //   title: '成功率(%)',
    //   key: 'successRate'
    // }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createTime = this.createrange[0];
    this.input.endTime = this.createrange[1];
    this.prox.caiWu_QueryMerchantStatistics(this.input).then(x => {
      this.dataList = x;
      let _totalOrderNum = 0, _totalAmount = 0, _commission = 0;
      this.dataList.map(p => {
        _totalOrderNum += p.successOrderNum;
        _totalAmount += p.successAmount;
        _commission += p.commission;
      })
      this.totalOrderNum = _totalOrderNum;
      this.totalAmount = _totalAmount;
      this.commission = _commission;
      this.showPaging(x);
    });
  }
  exportrecord() {
    var ids = this.selectedDataItems.map((x) => {
      return x.id;
    });
    this.input.ids = ids;
    this.prox.exportMerchant(this.input).then((x) => {
      location.href =
        AppConsts.remoteServiceBaseUrl +
        '/File/DownloadTempFile?FileToken=' +
        x.fileToken +
        '&fileName=' +
        x.fileName +
        '&fileType=' +
        x.fileType;
    });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    let mreq = new proxy.MerchantSimpleInputDto();
    new proxy.MerchantServiceProxy().queryAllList(mreq).then((x) => {
      this.merchants = x;
    });
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    this.getpage();
  }

}
